module.exports = global["contextualMenuCMS"] = require("-!/var/jenkins_agent/workdir/workspace/_bddf_ext_dcw_assets_INTEGRATION/sources/src/main/resources/node_modules/babel-loader/lib/index.js!./contextual-menu.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?contextualMenuCMS!./src/js/cms/contextual-menu.js-exposed
// module id = 211
// module chunks = 0